export default "__VITE_ASSET__8fac4cb4__"